import { Link } from "react-router-dom";
import useSeo from "../lib/useSeo";

export default function NotFound() {
  useSeo({
    title: "Page Not Found | Evon Polishing",
    noIndex: true,
  });

  return (
    <section className="section paper">
      <div className="container">
        <h1>Page not found</h1>
        <p className="muted">
          The page you’re looking for doesn’t exist.
        </p>
        <Link to="/" className="btn primary">
          Return Home
        </Link>
      </div>
    </section>
  );
}
